function Button({ button }) {
    return(
        <button className={button.class} onClick={button.onClick}>{button.displayText}</button>
    );
}

export default Button;